export const SOURCES_MAP = {
  COLLECTIONS: 'collections',
  POPUPS: 'popups',
  EXTERNAL_PROMOS: 'external_promos',
  DICTIONARIES: 'dictionaries',
  EVENTS: 'events',
  STICKERS: 'stickers',
  NEWS: 'news',
  CATEGORIES: 'categories',
  LOCAL_NOTIFICATIONS: 'local-notifications',
  PUSH_NOTIFICATIONS: 'push-notifications',
  FILTERS: 'filters',
  FILTER_GROUPS: 'filter-groups',
};

export const EVENT_TYPES_MAP = {
  GENERAL: 'general',
  EVENT: 'event',
};

